import { Bell } from 'lucide-react';
import { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router';
import { useUnreadCount } from '../../api/queries';
import { cx } from '../../lib/cx';
import { useT } from '../../lib/i18n';
import { commonMessages } from '../../lib/i18n/messages/common';
import { setAppBadge } from '../../lib/push';

/** Badge pill: `accent`, caps at 9+, hidden at 0; pops when the count increases. */
export function BellBadge({ count, className }: { count: number; className?: string }) {
  const prev = useRef(count);
  const [pop, setPop] = useState(false);
  useEffect(() => {
    if (count > prev.current) {
      setPop(true);
      const timer = setTimeout(() => setPop(false), 400);
      prev.current = count;
      return () => clearTimeout(timer);
    }
    prev.current = count;
    return undefined;
  }, [count]);
  if (count <= 0) return null;
  return (
    <span
      aria-hidden
      className={cx(
        'flex h-5 min-w-[20px] items-center justify-center rounded-full bg-accent px-1 text-xs font-bold text-accent-fg ring-2 ring-canvas',
        pop && 'animate-pop',
        className,
      )}
    >
      {count > 9 ? '9+' : count}
    </span>
  );
}

/** 44px bell in tab-root headers (DESIGN 4.18.1). */
export function BellButton() {
  const t = useT(commonMessages);
  const { data: unread = 0 } = useUnreadCount();
  useEffect(() => setAppBadge(unread), [unread]);
  return (
    <Link
      to="/notifications"
      className="iconbtn relative"
      aria-label={t('bellLabel', { count: unread })}
    >
      <Bell className="ic" strokeWidth={1.75} aria-hidden />
      <BellBadge count={unread} className="absolute top-1 right-0.5" />
    </Link>
  );
}
